import { createSlice } from '@reduxjs/toolkit';

import { IAccountModalState } from 'store/types/accountModalTypes';
import * as reducers from 'store/reducers/accountModalReducer';

export const initialState: IAccountModalState = {
  buttonText: null,
  callbackFunction: null,
  darkTheme: false,
  onDismissCallbackFn: null,
  hideToggleLink: false,
  modalContext: null,
  passwordResetToken: null,
  redirect: null,
  showCaptcha: false,
  subtitle: null,
  title: null,
};

export const accountModalSlice = createSlice({
  name: 'accountModalSlice',
  initialState,
  reducers,
});

export const {
  closeAccountModal,
  openCreateAccountModal,
  openForgotPasswordModal,
  openLoginModal,
  openResetPasswordModal,
  resetModalTextAndRedirect,
  setButtonText,
  setDarkTheme,
  setGuestEmail,
  setPasswordResetToken,
  setRedirect,
  setSubtitle,
  setTitle,
  triggerCaptcha,
  triggerLoginBeforeAction,
  triggerLoginBeforeCheckout,
} = accountModalSlice.actions;
export default accountModalSlice.reducer;
